var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0466 7.89876H14.4879C13.9704 7.89876 13.5504 8.31813 13.5504 8.83626C13.5504 9.35438 13.9704 9.77376 14.4879 9.77376H17.0472C17.5641 9.77376 17.9847 10.1944 17.9847 10.7113V22.9713C17.9847 23.4881 17.5641 23.9088 17.0472 23.9088H2.9541C2.43723 23.9088 2.0166 23.4881 2.0166 22.9713V10.7113C2.0166 10.1944 2.43723 9.77376 2.9541 9.77376H5.51348C6.0316 9.77376 6.45098 9.35438 6.45098 8.83626C6.45098 8.31813 6.0316 7.89876 5.51348 7.89876H2.9541C1.40348 7.89876 0.141602 9.16063 0.141602 10.7113V22.9713C0.141602 24.5219 1.40348 25.7838 2.9541 25.7838H17.0472C18.5979 25.7838 19.8597 24.5219 19.8597 22.9713V10.7113C19.8591 9.16001 18.5979 7.89876 17.0466 7.89876ZM6.50473 6.00626L9.0941 3.41688V15.7594C9.0941 16.2769 9.51348 16.6969 10.0316 16.6969C10.5497 16.6969 10.9691 16.2769 10.9691 15.7594V3.41688L13.5585 6.00626C13.7416 6.18938 13.9816 6.28063 14.2216 6.28063C14.4616 6.28063 14.7016 6.18938 14.8847 6.00626C15.251 5.64063 15.251 5.04626 14.8847 4.68063L10.6954 0.49063C10.3285 0.12438 9.73535 0.12438 9.3691 0.49063L5.1791 4.68063C4.81285 5.04626 4.81285 5.64063 5.1791 6.00626C5.54535 6.37251 6.13848 6.37251 6.50473 6.00626Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.bf639f52c41d77611a8d066675b42edf.svg";
export { ForwardRef as ReactComponent };